import _ from "lodash";
/** external */
import React, { useRef, useEffect } from "react";
import { SearchInput, EmptyState } from "@toddle-edu/ds-web";
import { NoSearchInFilterIllustration } from "@toddle-edu/ds-theme";

/** internal */
import { useI18n } from "Hooks";

/** relative */
import classes from "./ShortcutsPage.scss";
import ShortcutsSection from "./ShortcutsSection";

const ShortcutsPage = props => {
  const {
    testId,
    sectionHeaderRefs,
    setSidebarOption,
    selectedSidebarOption,
    shortcutList,
    searchTextFilter,
    setSearchTextFilter,
    isScrollManual,
  } = props;

  const localTestId = `${testId}-shortcutsPage`;

  useEffect(() => {
    // Scroll to the selected section when switching from settings page
    // Not scrolling when first section is selected as searchbox will get hidden
    if (selectedSidebarOption !== "UNIVERSAL") {
      sectionHeaderRefs?.current[
        selectedSidebarOption
      ]?.current?.scrollIntoView();
    }

    // Clear the search filter when switching to settings page
    return () => {
      setSearchTextFilter("");
    };
  }, []);

  const { t } = useI18n(["common"]);
  const containerRef = useRef();

  return (
    <div className={classes.container} ref={containerRef}>
      <div className={classes.searchBarContainer}>
        <SearchInput
          dsVersion="2.0"
          value={searchTextFilter}
          size="medium"
          placeholder={t("common:search_for_a_with_label", {
            label: t("common:shortcut"),
          })}
          onChange={setSearchTextFilter}
          testId={localTestId}
          focusSearchBySlash
        />
      </div>

      {_.isEmpty(shortcutList) ? (
        <EmptyState
          dsVersion="2.0"
          illustration={NoSearchInFilterIllustration}
          title={t("common:no_result_found")}
          subtitle={t("common:no_items_matching_your_search")}
        />
      ) : (
        _.map(shortcutList, section => (
          <ShortcutsSection
            key={section.id}
            section={section}
            parentContainerRef={containerRef}
            sectionHeaderRefs={sectionHeaderRefs}
            setSidebarOption={setSidebarOption}
            isScrollManual={isScrollManual}
          />
        ))
      )}
    </div>
  );
};

export default ShortcutsPage;
